var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1487 15.8419L2.13203 15.8586C1.90703 15.3669 1.76536 14.8086 1.70703 14.1919C1.76536 14.8002 1.9237 15.3502 2.1487 15.8419Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49896 8.64977C8.59432 8.64977 9.48229 7.7618 9.48229 6.66644C9.48229 5.57107 8.59432 4.68311 7.49896 4.68311C6.40359 4.68311 5.51562 5.57107 5.51562 6.66644C5.51562 7.7618 6.40359 8.64977 7.49896 8.64977Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.493 1.6665H6.50964C3.4763 1.6665 1.66797 3.47484 1.66797 6.50817V13.4915C1.66797 14.3998 1.8263 15.1915 2.13464 15.8582C2.8513 17.4415 4.38464 18.3332 6.50964 18.3332H13.493C16.5263 18.3332 18.3346 16.5248 18.3346 13.4915V11.5832V6.50817C18.3346 3.47484 16.5263 1.6665 13.493 1.6665ZM16.9763 10.4165C16.3263 9.85817 15.2763 9.85817 14.6263 10.4165L11.1596 13.3915C10.5096 13.9498 9.45964 13.9498 8.80964 13.3915L8.5263 13.1582C7.93464 12.6415 6.99297 12.5915 6.3263 13.0415L3.20964 15.1332C3.0263 14.6665 2.91797 14.1248 2.91797 13.4915V6.50817C2.91797 4.15817 4.15964 2.9165 6.50964 2.9165H13.493C15.843 2.9165 17.0846 4.15817 17.0846 6.50817V10.5082L16.9763 10.4165Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.05ef95a04f8d80099f4dbbee635d2d6a.svg";
export { ForwardRef as ReactComponent };